/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'file-upload-textarea';
const prefix = `${moduleName}.${componentName}`;

export const enterTextRadioLabel = `${prefix}.enterTextRadioLabel`;
export const uploadFileRadioLabel = `${prefix}.uploadFileRadioLabel`;

export const ENGLISH = {
    [enterTextRadioLabel]: 'Enter Text',
    [uploadFileRadioLabel]: 'Upload File',
};
